import React from 'react';
import List, { defaultFilters } from '../cruds/List';
import Iterate from '../components/container/Iterate';
import { OutputAttachmentRow } from '../components/output/OutputAttachments';
import Table, { Column } from '../components/container/Table';
import {AcknowledgeButton} from '../components/output/CrudButton';
import OutputValue, { OutputValueAcknowledgment } from '../components/output/OutputValue';
import { Switch, Route } from 'react-router-dom';
import WithRole from '../components/container/WithRole';
import MainContainer from '../components/MainContainer';
import { booleanFormatter } from '../functions/textFormatter';
import { Show_If_LastSDSBeenAcknowledged } from '../components/output/OutputBox';
import AcknowlegmentSDSHistory from './AcknowlegmentSDSHistory';

const ENTITY_NAME = 'acknowlegmentSDS';
const ENTITY_RUOTE = 'acknowlegmentSDS';
const TITLE = 'header.acknowlegmentSDS';

const CrudList = props => {
  const table = <Table>
                  <Column label="general.department" orderingName="DEPARTMENT_NAME"><OutputValue name="departmentName" /></Column>
                  <Column label="general.activity"><OutputValue name="activityName" /></Column>
                  <Column label="general.substance" orderingName="SUBSTANCE_CODE"><OutputValue name="substanceCode" /></Column>
                  <Column label="substances.sds" orderingName="SDS_ATTACHMENTS">
                    <Iterate rendered="lastApprovedSafetyDataSheet" on="lastApprovedSafetyDataSheet.attachments">
                      <OutputAttachmentRow />
                    </Iterate>
                  </Column>
                  <Column label="acknowlegmentSDS.acknowledger" orderingName="ACKNOWLEDGER">
                    <Show_If_LastSDSBeenAcknowledged>
                        <OutputValue name="acknowledger"/>
                    </Show_If_LastSDSBeenAcknowledged>
                  </Column>
                  <Column label="acknowlegmentSDS.acknowledgedTimestamp" orderingName="TIMESTAMP">
                    <Show_If_LastSDSBeenAcknowledged>
                      <OutputValueAcknowledgment name="acknowledgedTimestamp"/>
                    </Show_If_LastSDSBeenAcknowledged>
                  </Column>
                  <Column label="acknowlegmentSDS.acknowledged" orderingName="ACKNOWLEDGED">
                    <OutputValue name="hasLastSDSBeenAcknowledged" formatter={booleanFormatter}/>
                  </Column>
                  <Column>
                    <WithRole roles={['A', 'B', 'G']}>
                      <AcknowledgeButton entityRoute={props.match.url} />
                    </WithRole>
                  </Column>
                </Table>;

  return (
    <List title={TITLE}
          entityName={ENTITY_NAME}
          entityRoute={ENTITY_RUOTE}
          component={table}
          filters={defaultFilters()}
          defaultOrdering="DEPARTMENT_NAME"
          hideAddButton={true}
    />
  );
};

const AcknowlegmentSDS = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
        <Route exact path={basePath+"/history"} component={AcknowlegmentSDSHistory} />
      </Switch>
    </MainContainer>
  );
};

export default AcknowlegmentSDS;



// WEBPACK FOOTER //
// ./src/main/pages/AcknowlegmentSDS.js